import React from 'react';
import { Stack, Typography } from '@mui/material';
import CampaignProgressBar from './CampaignProgressBar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router';
import { theme } from '../../../theme';
import NewCampaignProgressBar from './NewCampaignProgressBar';

function CampaignBox(props) {
    const navigate = useNavigate();
    const isReviewed = props.campaign.current_progress === props.campaign.max_progress;
    const hasTopDraftsReviewed = props.campaign.num_top_drafts_reviewed === props.campaign.num_top_drafts;
    const numCardsWithOptimizationsRemaining = props.campaign.num_cards_with_optimizations - props.campaign.num_cards_with_optimizations_reviewed;
    const numCardsRemaining = props.campaign.total_drafts - props.campaign.num_drafts_reviewed;

    function handleClick () {
        navigate(`/physicianDashboard/headline/${props.campaign.campaign_id}`);
    }

    function getCardReviewText() {
        if (props.campaign.total_capturable_opportunity > 100000 && !hasTopDraftsReviewed) {
            return <NumericFormat value={props.campaign.total_capturable_opportunity / 100} prefix={'$'} suffix={' opportunity'} displayType={'text'} thousandSeparator={true} decimalScale={0} fixedDecimalScale={true} />;
        }
        if (hasTopDraftsReviewed && numCardsWithOptimizationsRemaining > 0) {
            return `${numCardsWithOptimizationsRemaining} cards w/ optimizations`
        }
        if (hasTopDraftsReviewed && numCardsWithOptimizationsRemaining === 0 && numCardsRemaining > 0) {
            return `${numCardsRemaining} unreviewed cards`
        }
        if (hasTopDraftsReviewed && numCardsWithOptimizationsRemaining === 0 && numCardsRemaining === 0) {
            return 'All cards reviewed'
        }
        return `${numCardsRemaining} unreviewed cards`;
    }

    if (props.campaign.campaign_type === 'compliance') {
        return (
            <Stack p={2} spacing={1} sx={{ borderRadius: '4px', backgroundColor: 'white', boxShadow: 7 }} onClick={handleClick} className='pendo-compliance-campaign-summary'>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    { isReviewed && <CheckCircleIcon sx={{ color:`${theme.palette.green.taskText}`, fontSize: '1.25rem'}}  /> }
                    <Typography variant='heavy' sx={{ fontSize: '18px' }}>{props.campaign.campaign_name}</Typography>
                </Stack>
                <Typography variant='normal' sx={{ fontSize: '14px' }}>Contract Compliance Review - <NumericFormat value={props.campaign.total_capturable_opportunity / 100} prefix={'$'} displayType={'text'} thousandSeparator={true} decimalScale={0} fixedDecimalScale={true} /> opportunity</Typography>
                <Stack spacing={1}>
                    <Typography variant='normal' sx={{ fontSize: '12px' }}>
                        { isReviewed ? 
                            <b>All swap opportunities reviewed</b> :
                            <><b>{props.campaign.current_progress}</b> of <b>{props.campaign.max_progress}</b> swap opportunities reviewed</>
                        }
                    </Typography>
                    <CampaignProgressBar isReviewed={isReviewed} num_steps={props.campaign.max_progress} current_step={props.campaign.current_progress} />
                </Stack>
            </Stack>
        );
    }

    if (props.campaign.campaign_type === 'optimization') {
        return (
            <Stack p={2} spacing={1} sx={{ borderRadius: '4px', backgroundColor: 'white', boxShadow: 7 }} onClick={handleClick} className='pendo-optimization-campaign-summary'>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <Typography variant='heavy' sx={{ fontSize: '18px' }}>{props.campaign.hospital.name}</Typography>
                </Stack>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <Typography variant='normal' sx={{ fontSize: '14px' }}>Preference Card Review - {getCardReviewText()}</Typography> 
                </Stack>
                <NewCampaignProgressBar
                    steps={
                        [
                            {
                                label: 'Top Cards',
                                completed: hasTopDraftsReviewed,
                            },
                            {
                                label: 'All Optimizations',
                                completed: numCardsWithOptimizationsRemaining === 0,
                            },
                            {
                                label: 'All Cards',
                                completed: numCardsRemaining === 0,
                            },
                        ]
                    }
                    hasTopDraftsReviewed={hasTopDraftsReviewed}
                    numCardsWithOptimizationsRemaining={numCardsWithOptimizationsRemaining}
                    numCardsRemaining={numCardsRemaining}
                    campaignOpportunity={props.campaign.total_capturable_opportunity}
                />
            </Stack>
        );
    }

    return <></>;
}

export default CampaignBox;
